export { getStaticProps } from '@ui/i18n/getStatic';
export { Stake as default } from '@ui/views/StakePage';
